export default __webpack_public_path__ + "static/media/617.6c0ba159.jpg";